"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ourLetterValidationSchema = ourLetterValidationSchema;
exports.makeOtherLetterValidationSchema = makeOtherLetterValidationSchema;
const Yup = __importStar(require("yup"));
const commonFields = {
    _offer: Yup.object().required("Wybierz ofertę"),
    // .min(1) obok .required() — `required` przepuszcza pustą tablicę, a pismo bez sprawy
    // serwer po cichu odrzuca (guard w LettersController.editCaseAssociations).
    _cases: Yup.array().min(1, "Wybierz co najmniej jedną sprawę").required("Wybierz sprawy"),
    description: Yup.string().required("Opis jest wymagany").max(300, "Opis może mieć maksymalnie 300 znaków"),
    creationDate: Yup.date()
        .required("Data utworzenia jest wymagana")
        .max(new Date(), "Data utworzenia nie może być z przyszłości")
        .test("creationDateValidation", "Pismo nie może być nadane przed utworzeniem", function (value) {
        return this.parent.registrationDate >= value;
    }),
    registrationDate: Yup.date()
        //.required('Data nadania jest wymagana')
        .max(new Date(), "Data nadania nie może być z przyszłości")
        .test("registrationDateValidation", "Pismo nie może być nadane przed utworzeniem", function (value) {
        if (value === undefined)
            return true;
        return value >= this.parent.creationDate;
    }),
    _entitiesMain: Yup.array().min(1, "Wybierz co najmniej jeden podmiot").required("Wybierz podmiot"),
    _editor: Yup.object().required("Podaj kto rejestruje"),
};
function ourLetterValidationSchema(isEditing) {
    return Yup.object().shape({
        ...commonFields,
        _template: isEditing ? Yup.object() : Yup.object().required("Wybierz szablon"),
    });
}
function makeOtherLetterValidationSchema(isEditing) {
    return Yup.object().shape({
        ...commonFields,
        number: Yup.string().required("Numer jest wymagany").max(50, "Numer może mieć maksymalnie 50 znaków"),
    });
}
